import { FC, useMemo } from 'react';

import Button, { ButtonVariants } from '@/components/new-design/Button';
import FastBackwardIcon from '@/pages/replay/components/FastBackwardIcon/FastBackwardIcon';
import FastForwardIcon from '@/pages/replay/components/FastForwardIcon/FastForwardIcon';
import styles from '@/pages/replay/components/ReplayActionsButtons/ReplayActionsButtons.module.css';
import SkipBackwardIcon from '@/pages/replay/components/SkipBackwardIcon/SkipBackwardIcon';
import SkipForwardIcon from '@/pages/replay/components/SkipFowardIcon/SkipFowardIcon';

interface ReplayHandActionButtonsProps {
  onClickPreviousGame: () => void;
  onClickNextGame: () => void;
  onClickSkipBackwardGame: () => void;
  onClickSkipForwardGame: () => void;
  gamesCount?: number;
  currentGamePosition?: number;
}
const ReplayHandActionButtons: FC<ReplayHandActionButtonsProps> = ({
  onClickPreviousGame,
  onClickNextGame,
  onClickSkipBackwardGame,
  onClickSkipForwardGame,
  currentGamePosition = 0,
  gamesCount = 0,
}) => {
  const buttons = useMemo(() => {
    return [
      { icon: <SkipBackwardIcon />, onClick: onClickSkipBackwardGame, disabled: currentGamePosition - 1 === 0 },
      { icon: <FastBackwardIcon />, onClick: onClickPreviousGame, disabled: currentGamePosition - 1 === 0 },
      { icon: <FastForwardIcon />, onClick: onClickNextGame, disabled: currentGamePosition === gamesCount },
      { icon: <SkipForwardIcon />, onClick: onClickSkipForwardGame, disabled: currentGamePosition === gamesCount },
    ];
  }, [
    onClickSkipBackwardGame,
    currentGamePosition,
    onClickPreviousGame,
    onClickNextGame,
    onClickSkipForwardGame,
    gamesCount,
  ]);

  return (
    <div className={styles.container}>
      {buttons.map((button) => (
        <Button
          disabled={button.disabled}
          onClick={button.onClick}
          variant={ButtonVariants.primary}
          className="flex !w-[5em] items-center justify-center"
        >
          {button.icon}
        </Button>
      ))}
    </div>
  );
};

export default ReplayHandActionButtons;
